import { useSignedStorageUrl } from '@/hooks/useSignedStorageUrl';
import { Skeleton } from '@/components/ui/skeleton';

interface SignedPhotoImageProps {
  photoRef: string;
  alt: string;
  className?: string;
}

export function SignedPhotoImage({ photoRef, alt, className }: SignedPhotoImageProps) {
  // Normalize photo reference to storage key
  const normalizeToStorageKey = (ref: string): string => {
    if (!ref.startsWith('http')) return ref; // Already a path
    
    // Strip public URL prefix
    if (ref.includes('/storage/v1/object/public/portal-uploads/')) {
      return ref.split('/storage/v1/object/public/portal-uploads/')[1].split('?')[0];
    }
    
    // Strip signed URL prefix
    if (ref.includes('/storage/v1/object/sign/portal-uploads/')) {
      return ref.split('/storage/v1/object/sign/portal-uploads/')[1].split('?')[0];
    }
    
    return ref;
  };

  const storageKey = normalizeToStorageKey(photoRef);
  const { url, loading } = useSignedStorageUrl('portal-uploads', storageKey);

  if (loading) {
    return <Skeleton className={className} />;
  }

  if (!url) {
    return (
      <div className={className + ' bg-muted flex items-center justify-center text-muted-foreground text-xs'}>
        Foto niet beschikbaar
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
    />
  );
}
